"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSource = exports.AvenProperty = void 0;
var AvenProperty;
(function (AvenProperty) {
    /**
     * Sessions created for Aven card applicants/applications.
     */
    AvenProperty["ORIGINATION"] = "ORIGINATION";
    AvenProperty["NOTARY"] = "NOTARY";
    /**
     * Sessions created for advisor users when they begin to the flow to create an Advisor account.
     * See landing page Advisor.vue
     */
    AvenProperty["ADVISOR"] = "ADVISOR";
    /**
     * Sessions created for advisor users when they're on an LP redirecting them to download
     */
    AvenProperty["ADVISOR_LP"] = "ADVISOR_LP";
    /**
     * Embedded = ad content hosted in an iframe on a third party site
     */
    AvenProperty["EMBEDDED"] = "EMBEDDED";
    AvenProperty["SCORE"] = "SCORE";
    AvenProperty["NET_WORTH"] = "NET_WORTH";
    AvenProperty["CRYPTO"] = "CRYPTO";
    AvenProperty["AUTO"] = "AUTO";
    AvenProperty["MY"] = "MY";
    AvenProperty["OPERATIONS"] = "OPERATIONS";
    AvenProperty["MLO"] = "MLO";
    AvenProperty["UCC"] = "UCC";
    /**
     * Sessions created for mortgage applicants/applications.
     * See landing page mortgage/LandingPage.vue
     */
    AvenProperty["MORTGAGE"] = "MORTGAGE";
    /**
     * Sessions created for deposit applicants/applications.
     * See landing page deposit/LandingPage.vue
     */
    AvenProperty["DEPOSIT"] = "DEPOSIT";
    /**
     * Sessions created for non-customers when they begin the flow to create a PIF code.
     * See landing page PifForAllLandingPage.vue
     */
    AvenProperty["PIF_FOR_ALL_SENDER"] = "PIF_FOR_ALL_SENDER";
    /**
     * Sessions created for non-customers when they visit Aven Reviews Landing Page -> avenreviews.com
     */
    AvenProperty["AVEN_REVIEWS"] = "AVEN_REVIEWS";
    /**
     * Sessions created for non-customers when they visit Best credit card for Home Depot -> comparecreditcardsforhomedepot.com/
     */
    AvenProperty["BEST_CREDIT_CARD_FOR_HOME_DEPOT"] = "BEST_CREDIT_CARD_FOR_HOME_DEPOT";
    /**
     * Retool dashboard that Customer Service Reps use
     */
    AvenProperty["CSR_RETOOL"] = "CSR_RETOOL";
    /**
     * Sessions created for non-customers when they visit Comparison Credit Card landing page -> https://comparisoncreditcard.com/
     */
    AvenProperty["COMPARE_CREDIT_CARDS"] = "COMPARE_CREDIT_CARDS";
    /**
     * Sessions created when users visit support pages or use the support widget
     */
    AvenProperty["SUPPORT"] = "SUPPORT";
    /**
     * Sessions created for users visiting the HELOC payments calculator site
     */
    AvenProperty["HELOC_PAYMENTS_CALCULATOR"] = "HELOC_PAYMENTS_CALCULATOR";
    /**
     * Sessions created for users visiting the compare HELOC rates site
     */
    AvenProperty["COMPARE_HELOC_RATES"] = "COMPARE_HELOC_RATES";
})(AvenProperty || (exports.AvenProperty = AvenProperty = {}));
/**
 * Known advertising sources for tracking campaign attribution.
 *
 * This enum provides type-safe constants for common ad sources to avoid magic strings.
 * Note: This is not exhaustive - ad sources typically come from UTM parameters and
 * can include any value, so additional sources may exist beyond those defined here.
 */
var AdSource;
(function (AdSource) {
    AdSource["hearth"] = "hearth";
})(AdSource || (exports.AdSource = AdSource = {}));
